export default __webpack_public_path__ + "static/media/banner.43ffad34.jpg";